import { Box, InputAdornment, TextField, Typography } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { FONT_ENUM } from '../../types/global/fonts.types';
import SearchIcon from '../CustomSVGIcons/SearchIcon';
import TabSelector from '../IntroductionModal/TabSelector';
import { useState } from 'react';

interface IEsInterest {
    header: string;
    options: string[];
    sx?: React.CSSProperties;
    onChange?: (selected: string[]) => void;
    initialValue?: string[];
}

const Interest: React.FC<IEsInterest> = ({ header, options, sx, onChange, initialValue }) => {
    const { themeStyle, device } = useThemeContext();
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedOptions, setSelectedOptions] = useState<string[]>(initialValue || []);

    // Handle tag click
    const handleSelectChange = (selected: string[]) => {
        setSelectedOptions(selected);
        onChange?.(selected);
    };

    // Filtered options (search + always show selected)
    const filteredOptions = Array.from(
        new Set([
            ...selectedOptions,
            ...options.filter(option => option.toLowerCase().includes(searchTerm.toLowerCase().trim())),
        ]),
    );

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                ...sx,
            }}>
            <Box sx={{ mt: 1 }}>
                <Typography
                    sx={{
                        textTransform: 'none',
                        fontSize: 20,
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        color: theme[themeStyle].tag_white,
                    }}>
                    {header}
                </Typography>
                <Typography
                    sx={{
                        textTransform: 'none',
                        fontSize: 14,
                        fontFamily: FONT_ENUM.MAIN_REGULAR,
                        color: theme[themeStyle].highlight,
                    }}>
                    Select at least one (1)
                </Typography>
            </Box>

            <TextField
                autoFocus
                variant="outlined"
                placeholder="Search"
                color="secondary"
                sx={{ my: 2, borderWidth: 0, width: '100%' }}
                InputProps={{
                    style: {
                        color: theme[themeStyle].lightWhite,
                        borderRadius: '10px',
                        paddingLeft: '8px',
                        fontSize: 14,
                        width: '100%',
                        backgroundColor: theme[themeStyle].signUpGrey,
                        maxHeight: '40px',
                    },
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon fill={theme[themeStyle].tag_white} style={{ width: '2em', height: '2em' }} />
                        </InputAdornment>
                    ),
                    onChange: e => setSearchTerm(e.target.value),
                }}
            />

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    height: 'fit-content',
                    width: '85%',
                }}>
                <TabSelector
                    themeStyle={themeStyle}
                    skipRefresh
                    disableAnimation
                    disableButton={false}
                    onChange={handleSelectChange}
                    initialValue={initialValue}
                    step={{
                        options: filteredOptions,
                        displayType: 'tabs',
                        hideArrow: true,
                    }}
                    tabsStyle={{
                        padding: 0,
                        width: '120%',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        marginTop: -20,
                    }}
                    pillTextStyle={{
                        fontSize: device.isMobile ? '10px' : '14px',
                        textAlign: 'center',
                        width: '100%',
                    }}
                />
            </Box>
        </Box>
    );
};

export { Interest };
